import { createStyles } from '@mui/styles';
import { APTheme } from "../../../core/TenantProvider/tenants";

const TrackingCodeContainerStyles = (theme: APTheme) => createStyles({
    trackingCodeContainer: {
        position: 'relative',
        '& h2': {
            fontSize: '26px',
            lineHeight: '34px',
            color: '#4a4a4a',
            textAlign: 'center',
            margin: '0 0 16px 0',
            fontWeight: '600',
            letterSpacing: '-1px',
            '@media(max-width: 768px)': {
                margin: '0 0 3rem 0',
                fontSize: '22px',
            },
        },

    },
    trackingCodeItemContainer: {
        boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)',
        marginBottom: '32px'
    },
    trackingCodeItem: {
        display: 'grid',
        listStyle: 'none',
        alignItems: 'center',
        gridTemplateColumns: '22px auto auto',
        justifyContent: 'stretch',
        gridColumnGap: 10,
        background: 'white',
        padding: '25px 30px',
        borderBottom: '1px solid rgba(45,145,233, 0.1)',
        fontSize: 16,
        lineHeight: '18px',
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease-in-out',
        '@media(max-width: 768px)': {
            display: 'block',
            position: 'relative',
            padding: '16px 20px 16px 55px',
            fontSize: 15,
        },

        '&:hover': {
            background: '#f5f5f5',
        },
        '& span': {
            letterSpacing: '-0.5px',
            '@media(max-width: 768px)': {
                display: 'block',
            },
            '&:nth-child(2)': {
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
            },
            '&:first-child': {
                '& svg': {
                    width: '1.375em',
                    height: '1.375em',
                },
                '@media(max-width: 768px)': {
                    position: 'absolute',
                    left: 20,
                    top: 0,
                    bottom: 0,
                    margin: 'auto',
                    height: 22,
                },
            },
            '&:last-child': {
                color: '#2D91E9',
                justifySelf: 'flex-end',
                '& svg': {
                    display: 'inline-block',
                    paddingRight: 5
                },
            },
        },
    },

    APSnackBar: {
        color: '#2D91E9',
        background: '#EAF3FF',
        boxSizing: 'border-box',
        padding: '20px',
        boxShadow: '0 5px 12px 0 rgba(0,0,0,0.08)',
        fontSize: 16,
        right: 'inherit',
        width: '-webkit-fill-available', 
        marginRight: '33px',
        left: 'auto',
        top: '50px',
        '@media(min-width: 1200px)': {
            marginRight: '82px'
        },
        '& div': {
            width: '100%',
            boxSizing: 'border-box',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            letterSpacing: '-0.5px',
            '& svg': {
                width: '20px',
                height: '20px',
                verticalAlign: 'middle',
            }
        }
    },
    snackBarWidth: {
        width: '-moz-available'
    },
    svgTick: {
        marginRight: 6,
    },
    svgIconClose: {
        cursor: 'pointer',
        pointerEvents: 'all',
        marginLeft: 'auto'
    }

});

export default TrackingCodeContainerStyles;
